<div class="reference-detail-container">
  <div class="model-header-actions">
    <div class="header-left-part">
      <button class="back-button" (click)="onBack()" [title]="'BUTTON.BACK' | translate">
        <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
      </button>

      <div class="reference-name-input-wrapper">
        <div class="reference-name-input" [title]="reference?.name || ''">
          {{ reference?.name || ('REFERENCES.DETAIL_TITLE' | translate) }}
        </div>
      </div>
    </div>

    <div class="header-right-part">
    <button class="primary-btn" [disabled]="saving" (click)="onSave()">
      @if (saving) {
      <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
      }
      {{ saveLabel }}
    </button>
    </div>
  </div>

  @if (loading) {
  <div class="state-card">
    <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
    <span>{{ 'MESSAGE.LOADING' | translate }}</span>
  </div>
  }

  @if (!loading && loadError) {
  <div class="state-card error">
    <span>{{ loadError }}</span>
  </div>
  }

  @if (!loading && !loadError) {
  <div class="detail-split-view">
    <div class="viewer-side">
      @if (loadingPreview) {
        <div class="preview-state">
          <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
        </div>
      } @else if (previewPages.length > 0) {
        <app-viewer [images]="previewPages" [imgIndex]="viewerImgIndex" [entities]="[]"
          [numOfPages]="previewMetadata?.totalPages || 0"
          [loading]="loadingPreview"
          (changeImgIndex)="onPreviewPageChange($event)"></app-viewer>
      } @else {
        <div class="preview-state">
          <span>{{ 'MESSAGE.NO_PREVIEW' | translate }}</span>
        </div>
      }
    </div>
    <div class="editor-side">
      <app-entities-editor [entities]="entities" [objects]="objects" (contentChanged)="onContentChanged()">
      </app-entities-editor>
    </div>
  </div>
  }
</div>
